"use strict";

function QuoteService(serviceWrapper, quoteModel, Util) {

	function getQuote() {
		return serviceWrapper.getQuote();
	}

	return {
		getQuote: getQuote
	}
}

QuoteService.createDummyService = function ($q, quoteModel, Util) {
	var conf = {};

	var serviceWrapper = function () {
		return {
			getQuote: function (data) {
				return $q(function (resolve, reject) {
					resolve({
						"return": "data"
					});
				});
			}
		}
	};
	return new QuoteService(new serviceWrapper());
}

QuoteService.bootstrap = function (http, $q, quoteModel, Util) {
	var conf = {
		getQuote: {
			method: 'PUT',
			url: '#URL',
			headers: {
				'EY-Access-Key': 'test123',
				'EY-Product-Type': 'pc',
				'EY-USER-TOKEN': 'eyJhbGciOiJIUzI1NiJ9.eyJhdXRob3JpdGllcyI6WyJRVU9URToxMDAxMDYyNTc1Il0sImlhdCI6MTQ2Mjg2MTM4OCwiZXhwIjoxNDYyODY0OTg4fQ.u1254ES1-_6com7Y2lSltBkVEV6z_WlP43MwbsuwnjE'
			}
		}
	};

	var serviceWrapper = function () {
		return {
			getQuote: function (data, success, error) {
				var req = conf.createPayment;
				req.params = data;
				http(req).then(function (response) {
					success(response);
				}, function (error) {
					console.log(error.status + ' : ' + error.statusText);
				});
			}
		}
	};
	return new QuoteService(new serviceWrapper(), quoteModel, Util);
}
